import React, { Component } from "react";
import { triggerStyles } from "../../common/styles";
import ContactGroupsList from "./ContactGroupsList";



class ContactGroups extends Component {
    constructor(props) {
        super(props);
        this.state = { showDetails: false };

        this.toggleDetailsHandler = this.toggleDetailsHandler.bind(this);
    }

    render() {
        return (
            <div style={{marginLeft: "6em", marginTop: "0.5em"}}>
               <div className="x-entry-point" onClick={this.toggleDetailsHandler} style={triggerStyles(this.state.showDetails)}>
                   Contact Groups
               </div>
               {this.state.showDetails ? <ContactGroupsList {...this.props} 
                                                            onComplete={this.toggleDetailsHandler}/>
                                       : null}
            </div>
        );
    }

    toggleDetailsHandler() {
        this.setState({showDetails: !this.state.showDetails});
    }
}
ContactGroups.propTypes = {
    authorId: React.PropTypes.string.isRequired,
    contactGroups: React.PropTypes.object,
    onChange: React.PropTypes.func
};

export default ContactGroups;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/contacts/components/ContactGroups.js
 **/